import {Alert, Chip, Typography, styled} from '@mui/material'
import {useFormContext} from 'react-hook-form'
import {useI18n} from 'store/Store'
import FormAutocomplete from 'components/Control/Form/FormAutocomplete'
import DancesList from './DancesList/DancesList'
import useDancesList from 'logic/DanceCollections/useDancesList'

const Dances = ({
    setInputValue,
    searchValue,
    dances = [],
    searchResults,
    onSelectValue,
    handleRemoveDance,
    handleMoveDance,
    isSearching,
}) => {
    const {i18n} = useI18n()

    const formContext = useFormContext()
    const {
        control,
        formState: {errors},
    } = formContext

    const {results, getOptionLabel, status, setStatus, handleSelectDance} =
        useDancesList({
            searchResults,
            onSelectValue,
            setInputValue,
        })

    const summaryTotalLabel = `${i18n.t('danceCollections.summaryTotal')}: ${
        dances.length
    }`

    return (
        <Container>
            <SearchSection>
                <SectionHeader variant="subtitle1">
                    {i18n.t('danceCollections.searchTitle')}
                </SectionHeader>

                {status && (
                    <Alert
                        severity={status.type}
                        onClose={() => setStatus(null)}
                        sx={{mt: 1}}>
                        {status.message}
                    </Alert>
                )}

                <FormAutocomplete
                    name="dances"
                    control={control}
                    error={errors?.dances?.message}
                    options={results}
                    getOptionLabel={getOptionLabel}
                    inputValue={searchValue}
                    onChangeInputValue={setInputValue}
                    placeholder={i18n.t('danceCollections.dancesPlaceholder')}
                    onSelectValue={handleSelectDance}
                    isLoading={isSearching}
                    clearOnBlur
                />
            </SearchSection>

            <CollectionSection>
                <SummaryChips>
                    <Chip
                        label={summaryTotalLabel}
                        color="primary"
                        variant="outlined"
                    />
                </SummaryChips>
                <DancesList
                    dances={dances}
                    handleRemoveDance={handleRemoveDance}
                    handleMoveDance={handleMoveDance}
                />
            </CollectionSection>
        </Container>
    )
}

export default Dances

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-block: 12px;
`

const SearchSection = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const CollectionSection = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const SectionHeader = styled(Typography)`
    font-weight: 600;
    text-transform: none;
`

const SummaryChips = styled('div')`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`
